import React from "react";
import { Helmet } from "react-helmet";
import { getUrl } from '../../../helpers';
/**
 * Dynamic Schema Markup for Product, Organization, and BreadcrumbList
 */
const DynamicSchemaMarkup = ({ products, organization, breadcrumbs, article }) => {
  const schemaData = [];
  const basePath = getUrl();

  // Product schema
  if (products && products.length) {
    schemaData.push({
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": products.map((product) => ({
          "@type": "Product",
          "name": product.name,
          "url": product.url,
          "description": product.description,
          "image": product.image,
          "brand": {
            "@type": "Brand",
            "name": product.brand
          },
          "model": product.model,
          "offers": product.offers || undefined
        }
      ))
    })
  }

  // Organization schema
  if (organization) {
    schemaData.push({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": organization.name,
      "url": organization.url,
      "logo": organization.logo
    });
  }

  // BreadcrumbList schema
  if (breadcrumbs && breadcrumbs.length) {
    schemaData.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": breadcrumbs.map((crumb, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": crumb.name,
        "item": basePath+crumb.link
      }))
    });
  }

  if (article) {
    schemaData.push({
      "@context": "https://schema.org",
      "@type": "Article",
      "@id": `${article.pageUrl}#article`,
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": article.pageUrl
      },
      "headline": article.headline,
      "inLanguage": article.inLanguage,
      "articleSection": "Case Study",
      "isAccessibleForFree": true,
      "url": article.pageUrl,
      "author": {
        "@type": "Organization",
        "@id": `${basePath}/${article.inLanguage}/home#org`
      },
      "publisher": {
        "@type": "Organization",
        "@id": `${basePath}/${article.inLanguage}/home#org`
      },
      "description": article.description,
      "keywords": article.keywords,
    })
  }

  return (
    <Helmet>
      {schemaData.map((entry, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
};

export default DynamicSchemaMarkup;